import React, { memo } from "react";
// import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { DetailFormMain, FormPart } from "../customer/styles/DetailFormStyles";
import AuthInput from "../../shared/authinput";
// import MainButton from "../../shared/Button";
import { DocumentsMain } from "./styles/VehicleStyles";
import NotFoundIcon from "../../shared/NotFoundIcon";
// import Vehicledoc from "../../../assets/images/Vehicledoc.png";

// const validationSchema = Yup.object().shape({
//   VehicleType: Yup.string().required("Vehicle Typeis required"),
//   VehicleName: Yup.string().required("Vehicle Name required"),
//   VehicleModel: Yup.string().required("Vehicle Model required"),
//   PlateNumber: Yup.string().required("Plate Number required"),
// });

const VehicleDetails = ({ data = {} }) => {
  const initialValues = {
    VehicleType: data?.vehicle_type || "",
    VehicleName: data?.name || "",
    VehicleModel: data?.model || "",
    PlateNumber: data?.plate_number || "",
  };
  const handleSubmit = (values) => {
    console.log("values", values);
  };
  return (
    <>
      {data && Object.keys(data).length > 0 ? (
        <DetailFormMain changeWidth={true}>
          <FormPart>
            <Formik
              initialValues={initialValues}
              // validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form autocomplete="off">
                  <div className="FormItem">
                    <Field
                      type="text"
                      name="VehicleType"
                      label="Vehicle Type"
                      component={AuthInput}
                      placeholder="Enter Vehicle Type"
                      disabled
                    />
                    <Field
                      type="text"
                      name="VehicleName"
                      label="Vehicle Name"
                      component={AuthInput}
                      placeholder="Enter Vehicle Name"
                      disabled
                    />
                  </div>
                  <div className="FormItem havePhone">
                    <Field
                      type="text"
                      name="VehicleModel"
                      label="Vehicle Model"
                      component={AuthInput}
                      placeholder="Enter Vehicle Model"
                      disabled
                    />
                    <Field
                      type="text"
                      name="PlateNumber"
                      label="Plate Number"
                      component={AuthInput}
                      placeholder="Enter Plate Number"
                      disabled
                    />
                  </div>
                  <DocumentsMain>
                    <h6>Documents</h6>
                    <div className="DocumentsWrapper">
                      {data?.document_urls?.map((value) => (
                        <img
                          src={value?.url}
                          key={value?.id}
                          alt="Vehicledoc"
                        />
                      ))}
                    </div>
                  </DocumentsMain>

                  {/* <div className="ButtonMain">
                  <MainButton type="submit" label="Approve" MT="90" />
                  <MainButton
                    type="button"
                    label="Reject"
                    MT="90"
                    border={true}
                  />
                </div> */}
                </Form>
              )}
            </Formik>
          </FormPart>
        </DetailFormMain>
      ) : (
        <NotFoundIcon MT="20" IconWidth="10" />
      )}
    </>
  );
};

export default memo(VehicleDetails);
